// SEARCH
//
// UI toggle logic lives in app.js so the search page can open/close before
// this bundle (Algolia + instantsearch.js) has been fetched. app.js lazy-loads
// this file on first open, and it self-initializes below as soon as it runs.

import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { searchBox, hits, hitsPerPage, index, stats } from 'instantsearch.js/es/widgets';

const searchClient = algoliasearch(window.algoliaAppId, window.algoliaApiKey);

const search = instantsearch({
	indexName: window.algoliaIndex,
	searchClient,
	routing: true,
	searchFunction(helper) {
		if (helper.state.query === '') {
			$('#pages-hits').closest('.row').hide();
			$('#documents-hits').closest('.row').hide();
			$('#spaces-hits').closest('.row').hide();
			$('#events-hits').closest('.row').hide();
			$('#articles-hits').closest('.row').hide();
			$('#searchbox .ais-SearchBox-reset').hide();
			$('.search-popup-section .wave-menu-2').show();
			return;
		}
		$('#searchbox .ais-SearchBox-reset').show();
		$('.search-popup-section .wave-menu-2').hide();
		helper.search();
	}
});


search.addWidgets([

    searchBox({
        container: '#searchbox',
		placeholder: 'Start typing to search',
		clear: false,
		queryHook(query, search) {
			search(query);
		},
		templates: {
			reset: `
				<svg class="ais-SearchBox-resetIcon" xmlns="http://www.w3.org/2000/svg" width="15.307" height="15.308" viewBox="0 0 15.307 15.308">
				<g transform="translate(-2812.398 -1873.399)">
				<g transform="translate(2820 1866.858) rotate(45)">
				<line x2="20" transform="translate(10.147) rotate(90)" fill="none" stroke="#fff" stroke-width="1.5"/>
				<line x2="20" transform="translate(0 10)" fill="none" stroke="#fff" stroke-width="1.5"/>
				</g>
				</g>
				</svg>
			`
		}
    }),

	hitsPerPage({
		container: '#hits-per-page',
		items: [
			{ label: '16 hits per page', value: 16, default: true },
		],
	}),

	hits({
		container: '#pages-hits',
		transformItems(items) {
			const filteredItems = items.filter(item => (
				item.type === 'pages' || item.type === 'team'
			));
			if (filteredItems.length === 0) {
				$('#pages-hits').closest('.row').hide();
			} else {
				$('#pages-hits').closest('.row').show();
			}
			return filteredItems;
		},
		templates: {
			item(hit) {
				return `
					<div class="hit">
						<a href="${hit.url}" class="link link-underline">${hit.title}</a>
					</div>
				`;
			},
		},
	}),

	hits({
		container: '#documents-hits',
		transformItems(items) {
			const filteredItems = items.filter(item => item.type === 'documents');
			if (filteredItems.length === 0) {
				$('#documents-hits').closest('.row').hide();
			} else {
				$('#documents-hits').closest('.row').show();
			}
			return filteredItems;
		},
		templates: {
			item(hit) {
				return `
					<div class="hit">
						<a href="${hit.url}" class="link link-underline" target="_blank" rel="noopener noreferrer">${hit.title}</a>
					</div>
				`;
			},
		},
	}),

    hits({
		container: '#spaces-hits',
		transformItems(items) {
			const filteredItems = items.filter(item => item.type === 'spaces');
			if (filteredItems.length === 0) {
				$('#spaces-hits').closest('.row').hide();
			} else {
				$('#spaces-hits').closest('.row').show();
			}
			return filteredItems;
		},
		templates: {
			item(hit) {
				return `
					<div class="hit">
						${hit.html}
					</div>
				`;
			},
		},
    }),

    hits({
		container: '#events-hits',
		transformItems(items) {
			const filteredItems = items.filter(item => item.type === 'events');
			if (filteredItems.length === 0) {
				$('#events-hits').closest('.row').hide();
			} else {
				$('#events-hits').closest('.row').show();
			}
			return filteredItems;
		},
		templates: {
			item(hit) {
				return `
					<div class="hit">
						${hit.html}
					</div>
				`;
			},
		},
    }),

    hits({
		container: '#articles-hits',
		transformItems(items) {
			const filteredItems = items.filter(item => item.type === 'articles');
			if (filteredItems.length === 0) {
				$('#articles-hits').closest('.row').hide();
			} else {
				$('#articles-hits').closest('.row').show();
			}
			return filteredItems;
		},
		templates: {
			item(hit) {
				return `
					<div class="hit">
						${hit.html}
					</div>
				`;
			},
		},
    }),

]);

search.start();
